import React from "react";
import { connect } from "dva";
import { modelUtils } from "@/utils";
import { utils_tool, component_tool, framework_tool } from "@/tool";
import columns from './columns'
import '../../../../styles/containers/biz/question/typeAuth.less'

const { WizCard, WizIcon, WizTree, WizLayout, WizForm, WizSpin, WizRow, WizCol } = component_tool;
const { WizContainer } = framework_tool;
const { Session, checkStrLength, deepReplaceKey } = utils_tool;
const getParamRecord = (history) => {
  let id = 0;//分类id
  let name = '' //分类名称
  let type = -1//分类类型
  let record = { id, name, type };
  if (history.location) {

    let pattern = /^[/biz/categoryType/g][^\s]*[/auth/g]$/
    if (pattern.test(history.location.pathname)) {
      if (history.location && history.location.record) {
        id = history.location.record["id"];
        name = history.location.record["name"];
        type = history.location.record["type"];
        record = { id, name, type };
        Session.set("questionTypeChapterInfo", record);
      } else {
        record = Session.get("questionTypeChapterInfo") || record;
      }
    }
  } else {
    record = Session.get("questionTypeChapterInfo") || record;
  }
  return record;
};
class TypeAuth extends WizContainer {
  componentName = "typeAuth";

  constructor(props) {
    super(props);
    const record = getParamRecord(props.history);
    this.state = {
      ...record,
      initialValue: {},
      defaultExpandedKeys: [],
      _key: '_key',
      loading: false,
      managerAuthVisible: false, //管理权限设置modal框
      useAuthVisible: false, //使用权限设置modal框
      managerTargetScopeRecord: { orgIds: [], positionIds: [], positionCategoryIds: [], personIds: [], sceneType: null, id: null }, //管理权限数据
      useTargetScopeRecord: { orgIds: [], positionIds: [], positionCategoryIds: [], personIds: [], sceneType: null, id: null }, //使用权限数据
    };
  }

  //START propsAndStateOnChange
  propsAndStateOnChange = {
    useAuthInfo: this._useAuthInfo.bind(this),
    managerAuthInfo: this._managerAuthInfo.bind(this),
    nodeList: this._nodeList.bind(this),
    saveManagerAuth: this._saveManagerAuth.bind(this),
    saveUseAuth: this._saveUseAuth.bind(this),
  };

  /**
 * 树搜索
 */
  onChange = e => {
    const { value } = e.target;
    let { treeData } = this.props
    const expandedKeys = this.dataList
      .map(item => {
        if (item.title.indexOf(value) > -1) {
          return getParentKey(item.key, treeData);
        }
        return null;
      })
      .filter((item, i, self) => item && self.indexOf(item) === i);
    this.setState({
      expandedKeys,
      searchValue: value,
      autoExpandParent: true,
    });
  };

  /**
 * 树结构节点选择
 * @param {*} selectedKeys 
 * @param {*} param1 
 */
  nodeOnSelect(selectedKeys, { selected, selectedNodes, node, event }) {
    if (selectedKeys && selectedKeys instanceof Array && selectedKeys.length > 0) {
      const selected = selectedKeys[0]
      let key = selected
      let title = node.props.title
      if (key === this.state.id) {
        this.setState({
          name: title,
        })
      }
      else {
        this.setState({
          name: title,
          id: key,
        })
        this.getAuthInfo(key)
      }
    } else {
      this.setState({
        id: null,
      })
    }
  }

  // 获取权限信息
  getAuthInfo(id) {
    this.setState({ loading: true })
    if (id) {
      this.doActions([
        {
          path: "questionType/authInfo",
          payload: {
            key: "useAuthInfoKey",
            apiParams: {
              id: id,
              sceneType: 125,
            },
          },
        },
        {
          path: "questionType/authInfo",
          payload: {
            key: "managerAuthInfoKey",
            apiParams: {
              id: id,
              sceneType: 126,
            },
          },
        },
      ]);
    }
  }

  _componentDidMount() {
    const { type, id } = this.state;
    this.doActions([
      {
        path: "questionType/nodeList",
        payload: {
          key: "nodeListKey",
          apiParams: {
            type: type,
          },
        },
      },
    ]);
    this.getAuthInfo(id)
  }

  _nodeList(nextProps, nextState) {
    let { nodeList } = nextProps;
    if (nodeList && nodeList["success"]) {
      let id = nextState['id']
      let treeData = nodeList['data']
      if (treeData && treeData.length > 0) {
        let len = 10
        let f = (v, parentIds) => {
          v && v.forEach(val => {
            if (parentIds) {
              val['parentIds'] = parentIds + ',' + val['value']
            } else {
              val['parentIds'] = val['value']
            }
            if (val['value'] === '' + id) {
              nextState['defaultExpandedKeys'] = val['parentIds'].split(',')
            }
            val['title'] = checkStrLength(val['title'], len);
            if (val['children'] && val['children'].length > 0) {
              f(val['children'], val['parentIds'])
            }
          });
        }
        f(treeData, '')
      }
      nextState['treeData'] = treeData
      return true;
    } else {
      return false;
    }
  }


  /**
   * 过滤字段值为undefined&null的字段
   * @param {Object} fieldsValue
   */
  fitterFieldsValue(fieldsValue) {
    let fitterValues = {};
    fitterValues["sceneType"] = fieldsValue["sceneType"]

    if (fieldsValue["groupId"] && fieldsValue["groupId"].length) {
      fitterValues["groupId"] = Number(fieldsValue["groupId"].map((p) => p["id"]).toString());
    } else {
      fitterValues["orgIds"] = fieldsValue["orgIds"] && fieldsValue["orgIds"].map((p) => p["id"]);
      fitterValues["positionIds"] = fieldsValue["positionIds"] && fieldsValue["positionIds"].map((p) => p["id"]);
      fitterValues["positionCategoryIds"] = fieldsValue["positionCategoryIds"] && fieldsValue["positionCategoryIds"].map((p) => p["id"]);
      fitterValues["personIds"] = fieldsValue["personIds"] && fieldsValue["personIds"].map((p) => p["id"]);
    }

    fitterValues["id"] = this.state.id;
    return fitterValues;
  }

  _saveUseAuth(nextProps, nextState) {
    this.useSumbit = true;
    let { saveUseAuth } = nextProps;
    if (saveUseAuth && saveUseAuth["success"]) {
      wizNotice.success("操作成功");
      nextState.loading = false
    } else {
      wizNotice.error((saveUseAuth && saveUseAuth["msg"]) || "操作失败,请稍后尝试");
    }
    return false;
  }

  _saveManagerAuth(nextProps, nextState) {
    this.managerSumbit = true;
    let { saveManagerAuth } = nextProps;
    if (saveManagerAuth && saveManagerAuth["success"]) {
      wizNotice.success("操作成功");
      nextState.loading = false
    } else {
      wizNotice.error((saveManagerAuth && saveManagerAuth["msg"]) || "操作失败,请稍后尝试");
    }
    return false;
  }
  _managerAuthInfo(nextProps, nextState) {
    let { managerAuthInfo } = nextProps;
    if (managerAuthInfo && managerAuthInfo["success"]) {
      managerAuthInfo["data"]['message'] = [`共${managerAuthInfo["data"]['scopeCount'] || 0}人`]
      //managerAuthInfo["data"]['message'] = [{name:'受众人数',value:managerAuthInfo["data"]['scopeCount']||0}]
      nextState['managerTargetScopeRecord'] = managerAuthInfo["data"]
      nextState.loading = false
      nextState._key = new Date().getTime()
      return true
    } else {
      wizNotice.error((managerAuthInfo && managerAuthInfo["msg"]) || "操作失败,请稍后尝试");
    }
    return false;
  }
  _useAuthInfo(nextProps, nextState) {
    let { useAuthInfo } = nextProps;
    if (useAuthInfo && useAuthInfo["success"]) {
      useAuthInfo["data"]['message'] = [`共${useAuthInfo["data"]['scopeCount'] || 0}人`]
      //useAuthInfo["data"]['message'] = [{name:'受众人数',value:useAuthInfo["data"]['scopeCount']||0}]
      nextState['useTargetScopeRecord'] = useAuthInfo["data"]
      nextState.loading = false
      nextState._key = new Date().getTime()
      return true
    } else {
      wizNotice.error((useAuthInfo && useAuthInfo["msg"]) || "操作失败,请稍后尝试");
    }
    return false;
  }

  _sumbit(values) {
    this.setState({ loading: true })
    const { managerTargetScopeRecord, useTargetScopeRecord } = values
    const usePar = this.fitterFieldsValue(useTargetScopeRecord)
    let { type } = this.state
    if (type && type == 1) {
      this.doAction({
        path: 'questionType/saveAuth',
        payload: {
          key: 'saveUseAuthKey',
          apiParams: {
            ...usePar,
            sceneType: 125
          }
        },
        autoInit: true,
      })
    } else {
      const managerPar = this.fitterFieldsValue(managerTargetScopeRecord)
      this.doActions([{
        path: 'questionType/saveAuth',
        payload: {
          key: 'saveManagerAuthKey',
          apiParams: {
            ...managerPar,
            sceneType: 126
          }
        },
        autoInit: true,
      },
      {
        path: 'questionType/saveAuth',
        payload: {
          key: 'saveUseAuthKey',
          apiParams: {
            ...usePar,
            sceneType: 125
          }
        },
        autoInit: true,
      }])
    }

  }

  _render() {
    const { id, name, type, managerTargetScopeRecord, useTargetScopeRecord, managerAuthVisible, useAuthVisible, defaultExpandedKeys, _key, loading } = this.state
    let { questionTypeLoading } = this.props;

    const onSubmit = this._sumbit.bind(this)

    const formProps = {
      key: _key,
      ref: 'form',
      columns: columns(managerTargetScopeRecord, useTargetScopeRecord, type),
      onSubmit,
      record: null,
      preview: null,
      footer: undefined,
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 17 }
      }
    }

    let desc =
      type && type == 1 ?
        <WizCol span={22} push={1}>
          <div className="header-font">1. 请点击需要设置权限的分类节点，然后设置相应的受众范围。</div>
          <div className="header-font">2. 所有分类默认受众为全员；若设置受众后，则使用自定义的范围。</div>
          <div className="header-font">3. 仅指定受众范围内的学员可在学员端查看对应分类及关联课程。</div>
        </WizCol> :
        <WizCol span={22} push={1}>
          <div className="header-font">1. 请点击需要设置权限的题目分类节点，然后设置对应分类的管理权限及使用权限。</div>
          <div className="header-font">2. 若子分类未设置权限，默认继承上级权限；若设置权限则以设置范围为准。</div>
          <div className="header-font">3. 符合管理权限范围的人员可对该分类及其子分类和对应分类下题目进行管理；<br />&nbsp;&nbsp;&nbsp;&nbsp;符合使用权限范围的人员创建考试时允许引用该分类下的题目（管理范围内的人员默认有使用权限，无需设置）。</div>
          <div className="header-deepen-font">设置后的权限需要用户重新登录才会生效。</div>
        </WizCol>

    return (
      <WizSpin tip={"加载中"} spinning={loading}>
        <WizCard>
          <WizLayout key={id + '@Layout'}>
            <WizLayout.Header>
              <WizRow>
                <WizCol span={2} >
                  <WizIcon type="question-circle" />
                  <span className="header-icon-font">设置说明</span>
                </WizCol>
                {desc}
              </WizRow>
            </WizLayout.Header>
          </WizLayout>
          <WizLayout className="sider-layout" >
            <WizLayout.Sider width={236} collapsedWidth={236} trigger={null} breakpoint="lg" collapsible={false} className="sider">
              <div className="sider-header"><WizIcon type="unordered-list" /> <span className="sider-header-font"> 分类</span></div>
              <WizTree style={{ maxWidth: 234, overflow: 'auto' }} onSelect={this.nodeOnSelect.bind(this)} key={defaultExpandedKeys.join(',')}
                autoExpandParent={true} defaultExpandParent={true} defaultExpandedKeys={defaultExpandedKeys} defaultSelectedKeys={[this.state.id + '']}
                treeData={deepReplaceKey(this.state.treeData ? this.state.treeData : [], [{ key: 'value', value: 'key' }])} />
            </WizLayout.Sider>
            <WizLayout.Content className="question-type-auth-content" >
              {this.state.id ? <WizForm {...formProps} /> : null}
            </WizLayout.Content>
          </WizLayout>
        </WizCard>
      </WizSpin>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { questionType } = state;
  const managerAuthInfo = modelUtils.getModelEntity(questionType, "managerAuthInfoKey");
  const useAuthInfo = modelUtils.getModelEntity(questionType, "useAuthInfoKey");
  const nodeList = modelUtils.getModelEntity(questionType, "nodeListKey");

  const saveManagerAuth = modelUtils.getModelEntity(questionType, "saveManagerAuthKey");
  const saveUseAuth = modelUtils.getModelEntity(questionType, "saveUseAuthKey");

  const load = modelUtils.getLoadingState(state, ["questionType"]);
  return {
    managerAuthInfo,
    useAuthInfo,
    nodeList,
    treeData: [],
    saveManagerAuth,
    saveUseAuth,
    ...load,
  };
};

export default connect(mapStateToProps)(TypeAuth);
